module.exports = __webpack_public_path__ + "img/pin-location.993851c8.svg";